import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class CheckoutGuard implements CanActivate {
  constructor(private router: Router) {
    
  }

  canActivate(): boolean {
    return true;
    const allowed = sessionStorage.getItem('allowCheckout');

    if (allowed === 'true') {
      // Limpio el flag para que no puedan volver a entrar sin una nueva acción válida
      sessionStorage.removeItem('allowCheckout');
      return true;
    }

    // Redirige si se accede manualmente
    this.router.navigate(['/']);
    return false;
  }
}